export default __webpack_public_path__ + "static/media/dos.cd861d3e.jpeg";